import React, { useState, useEffect } from "react";
import { useUI } from "../../context/UIContext";
import { editAppPid, getAppInfo } from "../../api";

export default function EditAppPidModal({ serverCode, appName }) {
  const { toast, closeModal } = useUI();
  const [pid, setPid] = useState("");
  const [description, setDescription] = useState("");
  const [command, setCommand] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    getAppInfo(serverCode, appName).then(({ ok, data }) => {
      if (alive && ok) {
        setDescription(data.description || "");
        setCommand(data.command || "");
        setPid(data.processId ? String(data.processId) : "");
      }
    });
    return () => {
      alive = false;
    };
  }, [serverCode, appName]);

  const submit = async () => {
    const p = parseInt(pid, 10);
    if (!p || p <= 0) return toast("Nhập PID hợp lệ (> 0)", "err");

    setBusy(true);
    try {
      const { ok, status, data } = await editAppPid(
        serverCode,
        appName,
        p,
        description.trim(),
        command.trim()
      );
      if (ok) {
        toast(data.message || "Đã cập nhật PID", "ok", 5000);
        closeModal();
      } else if (status === 404) {
        toast(
          data.message ||
          "Không tìm thấy app trên máy chủ này, vui lòng chọn máy chủ khác",
          "err",
          6000
        );
      } else if (status === 503) {
        toast(data.message || "Máy chủ chưa kết nối", "warn", 5000);
      } else {
        toast(data.message || "Lỗi server", "err");
      }
    } catch {
      toast("Không kết nối được BackendNode", "err");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <div
        style={{
          fontSize: "12px",
          color: "var(--dim)",
          fontFamily: "var(--font-mono)",
          marginBottom: "14px",
        }}
      >
        Máy chủ <strong style={{ color: "var(--primary)" }}>{serverCode}</strong> · Ứng dụng: <strong style={{ color: "var(--text)" }}>{appName}</strong>
      </div>

      <div className="field-lbl">PID mới *</div>
      <input
        className="field-inp"
        type="number"
        value={pid}
        min="1"
        placeholder="VD: 12345"
        onChange={(e) => setPid(e.target.value)}
        autoFocus
      />

      <div className="field-lbl">Mô tả</div>
      <textarea
        className="field-inp"
        rows={2}
        maxLength={255}
        value={description}
        placeholder="Mô tả app này dùng làm gì…"
        onChange={(e) => setDescription(e.target.value)}
        style={{ resize: "vertical", fontFamily: "var(--font-body)", height: "auto", padding: "10px 13px" }}
      />

      <div className="field-lbl">Lệnh khởi chạy (cho Start/Restart)</div>
      <textarea
        className="field-inp"
        rows={2}
        value={command}
        placeholder="VD: C:\\app\\start.bat  hoặc  node C:\\app\\index.js"
        onChange={(e) => setCommand(e.target.value)}
        style={{ resize: "vertical", fontFamily: "var(--font-mono)", height: "auto", padding: "10px 13px" }}
      />

      <div className="modal-footer" style={{ marginTop: "15px" }}>
        <button className="mbtn mbtn-cancel" onClick={closeModal} disabled={busy}>
          Huỷ
        </button>
        <button className="mbtn mbtn-primary" onClick={submit} disabled={busy}>
          {busy ? "Đang tra cứu…" : "💾 Cập nhật"}
        </button>
      </div>
    </div>
  );
}
